import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center text-[#0F3D2E]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
